module.exports = __webpack_public_path__ + "img/Youtube.2b6cdc31.svg";